import React from 'react';
import './Toggle.scss';

type Props = {
  checked?: boolean;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  onChange?: (checked: boolean) => void;
};

const Toggle = (props: Props) => {
  const {
    checked = false,
    disabled = false,
    size = 'md',
    label = '',
    onChange = () => {},
  } = props;

  let finalCssClass = 'lw-toggle';

  switch (size) {
    case 'sm':
      finalCssClass += ' lw-toggle-sm';
      break;
    case 'lg':
      finalCssClass += ' lw-toggle-lg';
      break;
    default:
      finalCssClass += ' lw-toggle-md';
      break;
  }

  if (disabled) {
    finalCssClass += ' lw-toggle-disabled';
  }

  if (checked) {
    finalCssClass += ' lw-toggle-checked';
  }

  const handleToggle = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <div className="lw-toggle-container">
      {label && <label className="lw-toggle-label">{label}</label>}
      <div 
        className={finalCssClass}
        onClick={handleToggle}
        role="switch"
        aria-checked={checked}
        aria-disabled={disabled}
        tabIndex={disabled ? -1 : 0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleToggle();
          }
        }}
      >
        <div className="lw-toggle-slider">
          <div className="lw-toggle-thumb"></div>
        </div>
      </div>
    </div>
  );
};

export default Toggle;
